import urlUtils from '@utils/url.utils';

const hostName = window?.location?.host;
const docsHost = urlUtils.isDev()
    ? 'https://devhelp.ptengine.jp/docs/'
    : 'https://help.ptengine.jp/docs/';

const utmTag = '?utm_source=product';

const docs = {
    install_pte: 'ptengine-tag',
    install_ptx: 'ptengine-tag',
    identifyUser: 'ptx-user-identification',
    goal: 'ptx-what-is-goal',
    usergroup: 'ptx-introduction-usergroups',
    campaign: 'ptx-introduction-personalization',
    inline: 'ptx-inline',
    abTest: 'ptx-how-to-do-abtest',
    eventSetting: 'ptx-event-settings',
    faqTrackingMark: 'ptx-faq-tracking-mark',
    gtmCodeSetting: 'ptx-code-setting#2-toc-title',
    gtmReadMe: 'ptx-google-tag-manager-read-me',
    inlineAntiFlickerTag: 'ptx-inline-anti-flicker-tag',
    faqManualSetting: 'ptx-code-setting#1-toc-title',
    GroupCannotSetOut: 'ptx-group-cannot-set-out',
    gtm: 'ptx-google-tag-manager',
    setOut: 'ptx-group-cannot-set-out',
    crossDomain: 'ptx-crossdomain-setting',
    heatmap: 'ptx-work-with-heatmap',
    pathAbsoluteRelative: 'ptx-path-absolute-relative',
    dataSetting: 'ptx-datasetting',
    newPtengine: 'new-ptengine'
} as const;

export default Object.fromEntries(
    Object.entries(docs).map(([docName, url]) => [docName, docsHost + url + utmTag])
) as Record<keyof typeof docs, string>;
